import React from "react";
import {
  Navigate,
  Route,
  createBrowserRouter,
  createRoutesFromElements,
} from "react-router-dom";

import { useUser } from "@/context/user";
import storage from "@/utils/storage";
import { getRoutes } from "@/utils/helpers";

import Layout from "@/components/layout";
import AuthLayout from "@/components/auth/layout";
import PublicRoute from "@/components/hoc/public-routes";
import ProtectedRoute from "@/components/hoc/protected-routes";

import DashboardPage from "@/pages/dashboard";
import LoginPage from "@/pages/auth/login";
import ForgotPassword from "@/pages/auth/forgot-password";
import ResetPassword from "@/pages/auth/reset-password";
import SettingsPage from "@/pages/settings";
import ProductsPage from "@/pages/products";
import ProductPage from "@/pages/product";
import BrandsPage from "@/pages/brands";
import BrandPage from "@/pages/brand";
import InvoicesPage from "@/pages/invoices";
import CampaignsPage from "@/pages/campaigns";
import AnalyticsPage from "@/pages/analytics";
import InventoryPage from "@/pages/inventory";
import ProfilePage from "@/pages/profile";
import OrdersPage from "@/pages/orders";
import InventoryDetailsPage from "@/pages/inventory-details";

const router = createBrowserRouter(
  createRoutesFromElements(
    <React.Fragment>
      <Route
        path="*"
        Component={() => {
          const routes = getRoutes();
          const isAuthenticated = useUser((state) => state.isAuthenticated);
          const vid = storage.getItem("vid");

          if (isAuthenticated || vid) return <Navigate to={routes.dashboard} />;

          return <Navigate to={routes.signIn} />;
        }}
      />

      <Route element={<PublicRoute />}>
        <Route element={<AuthLayout />}>
          <Route path="/sign-in" element={<LoginPage />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset-password" element={<ResetPassword />} />
        </Route>
      </Route>

      <Route element={<ProtectedRoute />}>
        <Route element={<Layout />}>
          <Route path="/dashboard/:vid" element={<DashboardPage />} />
          <Route path="/vendor/:vid">
            <Route path="settings" element={<SettingsPage />} />
            <Route path="profile" element={<ProfilePage />} />
            <Route path="invoices" element={<InvoicesPage />} />
            <Route path="analytics" element={<AnalyticsPage />} />
            <Route path="campaigns" element={<CampaignsPage />} />
            <Route path="brands">
              <Route path="" element={<BrandsPage />} />
              <Route path=":bid" element={<BrandPage />} />
            </Route>
            <Route path="products" element={<ProductsPage />} />
            <Route path="inventory">
              <Route path="" element={<InventoryPage />} />
              <Route path=":iid" element={<InventoryDetailsPage />} />
            </Route>
            <Route path="orders" element={<OrdersPage />} />
            <Route path="product">
              <Route path="" element={<ProductPage />} />
              <Route path=":pid" element={<ProductPage />} />
            </Route>
          </Route>
        </Route>
      </Route>
    </React.Fragment>
  )
);

export default router;
